// Экраны внутри шага оплаты (RBXGD-1110).
//
// Компонент оплаты рисует не один экран, а два: сначала выбор платёжного
// метода, потом «Проверьте данные» (у паков перед ними есть ещё оплата с
// баланса). Держит он их в своём currentStep, и для Transfer.vue шаг всё это
// время оставался одним — две остановки навигации делили одну запись в истории.
// Браузерный «Назад» с проверки данных перепрыгивал выбор метода и уводил
// сразу на ввод ника.
//
// Миксин связывает внутренний currentStep с родителем в обе стороны: наверх
// уходит текущий экран (родитель делает из него токен шага и запись в истории),
// обратно приходит экран, на который вернул «Назад».
//
// Компонент, который подключает миксин, обязан держать экран в data.currentStep.
export default {
  props: {
    // Экран, на который нас возвращает родитель. null — не трогать, компонент
    // сам решает, с какого экрана начать: у паков это зависит от баланса.
    subStep: {
      type: Number,
      default: null
    }
  },
  watch: {
    currentStep: {
      // sync по той же причине, что и в stepBackButton: отложенный вотчер Vue 2
      // схлопывает две смены экрана в одном тике, и запись в истории теряется.
      sync: true,
      handler(step) {
        this.$emit('subStep', step)
      }
    },
    subStep(step) {
      // Условие обязательно: без него эхо от нашего же $emit вернулось бы сюда
      // и переключало экран второй раз.
      if (step !== null && step !== this.currentStep) this.currentStep = step
    }
  },
  beforeDestroy() {
    // Шаг оплаты покинут: родитель больше не должен считать, что мы стоим на
    // одном из его экранов, иначе номер экрана утечёт в следующий заход и
    // «Назад» будет считать проверку данных уже открытой.
    this.$emit('subStep', null)
  }
}
